export const API_URL = "https://baritiascolta.ottomanelliandrea.it/api/";